<template>
  <v-dialog v-model="show" max-width="400px" persistent>
    <v-card>
      <ModelTitle title="Select Quantity" @close="close()" />
      <v-card-text class="text-center">
        <h2 class="font-weight-bold mb-4 text-h2 mt-2">{{ quantity }}</h2>
        <div
          v-if="!allowExceedStock && maxQuantity !== null"
          class="text-caption mb-4"
        >
          Max in stock: <strong>{{ maxQuantity }}</strong>
        </div>

        <v-row dense>
          <v-col v-for="num in 9" :key="num" cols="4">
            <v-btn outlined block @click="append(num)">{{ num }}</v-btn>
          </v-col>
          <v-col cols="4">
            <v-btn block outlined @click="clear">C</v-btn>
          </v-col>
          <v-col cols="4">
            <v-btn block outlined @click="append(0)">0</v-btn>
          </v-col>
          <v-col cols="4">
            <v-btn block outlined @click="backspace">←</v-btn>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions class="justify-end">
        <v-btn text @click="close">Cancel</v-btn>
        <v-btn color="primary" @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "QuantitySelectorDialog",
  props: {
    value: { type: Boolean, default: false },
    initialQty: { type: Number, default: 0 },
    maxQuantity: { type: Number, default: null }, // for stock limit
    allowExceedStock: { type: Boolean, default: false }, // can exceed?
  },
  data() {
    return {
      show: this.value,
      quantity: this.initialQty.toString(),
      replace: true,
    };
  },
  watch: {
    value(val) {
      this.show = val;
      if (val) {
        this.quantity = this.initialQty.toString();
        this.replace = true; // reset replace on open
      }
    },
    show(val) {
      this.$emit("input", val);
    },
  },
  methods: {
    append(num) {
      if (this.replace) {
        this.quantity = num.toString();
        this.replace = false;
      } else {
        this.quantity += num.toString();
      }
    },
    clear() {
      this.quantity = "";
      this.replace = true;
    },
    backspace() {
      this.quantity = this.quantity.slice(0, -1);
      if (this.quantity.length === 0) {
        this.replace = true;
      }
    },
    close() {
      this.show = false;
    },
    save() {
      let qty = parseInt(this.quantity, 10);
      if (isNaN(qty)) qty = 0;

      if (
        !this.allowExceedStock &&
        this.maxQuantity !== null &&
        qty > this.maxQuantity
      ) {
        // Throw error toast or alert
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: `Quantity exceeds available stock (${this.maxQuantity})`,
          });
        return; // do NOT emit
      }

      this.$emit("save", qty);
      this.close();
    },
  },
};
</script>

<style scoped>
h2 {
  min-height: 48px;
}
</style>